"use client";
import { usePowerSearch } from "../contexts/power-search-context";
import MultiSelectWithSearch from "../MultiSelectWithSearch";
import Button from "react-bootstrap/Button";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { mixpanelTrack } from "shared/trackEvents/mixpanelTracking";
import { isOpenRemunerationPlan } from "shared/plans";
import {
  POWER_SEARCH_EVENT_NAMES,
  MIXPANEL_PROPS,
} from "shared/trackEvents/constants";

const MultiSelectQualificationsWithSelectAll = ({
  qualificationsMap,
  filterKey,
  title,
  currentFilterValue,
  all_qualifications,
  updateFilter,
  dispatchLocal,
}) => {
  const currentUser = useSelector((state) => state.users.user);

  if (!qualificationsMap || Object.keys(qualificationsMap).length === 0)
    return null;

  const options = Object.keys(qualificationsMap).map((key) => ({
    label: key,
    value: qualificationsMap[key],
  }));

  const handleSelectAll = useCallback(() => {
    const newAllQualificationsState = !all_qualifications;
    dispatchLocal({
      type: "SET_FILTER",
      payload: { name: "all_qualifications", value: newAllQualificationsState },
    });
    updateFilter(filterKey, newAllQualificationsState ? options : []);
  }, [all_qualifications, dispatchLocal, updateFilter, filterKey, options]);

  const handleChange = useCallback(
    (value) => {
      updateFilter(filterKey, value);
      if (value.length === 0 && all_qualifications) {
        dispatchLocal({
          type: "SET_FILTER",
          payload: { name: "all_qualifications", value: false },
        });
      }

      // Track qualifications filter selection
      if (value.length > 0) {
        const eventName = isOpenRemunerationPlan(currentUser)
          ? POWER_SEARCH_EVENT_NAMES.OR_POWER_SEARCH_FILTER_QUALIFICATIONS_CLICKED
          : POWER_SEARCH_EVENT_NAMES.OD_POWER_SEARCH_FILTER_QUALIFICATIONS_CLICKED;

        mixpanelTrack(eventName, {
          [MIXPANEL_PROPS.FILTER_OPTION]: value[value.length - 1],
          [MIXPANEL_PROPS.FILTER_CATEGORY]: title,
          userEmail: currentUser?.email,
        });
      }
    },
    [
      updateFilter,
      filterKey,
      all_qualifications,
      dispatchLocal,
      currentUser,
      title,
    ]
  );

  return (
    <div
      className="mt-2"
      style={{ marginBottom: "10px", paddingBottom: "16px" }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <p
          className="mb-0"
          style={{ fontSize: "14px", fontWeight: "500", color: "#AF6A3A" }}
        >
          {title}
        </p>
        <Button variant="link" onClick={handleSelectAll} className="small p-0">
          {!all_qualifications ? "Select all" : "Unselect all"}
        </Button>
      </div>
      <MultiSelectWithSearch
        options={options}
        value={currentFilterValue}
        onChange={handleChange}
        placeholder={`Select ${title}`}
        className={"form-input debounce-search-input mt-1"}
      />
    </div>
  );
};

const QualificationsFilter = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const {
    filterOptions,
    qualifications,
    all_qualifications,
    updateFilter,
    dispatchLocal,
  } = usePowerSearch();

  const qualificationsMap = filterOptions.qualifications_list || {};

  if (Object.keys(qualificationsMap).length === 0) return null;

  return (
    <div className="">
      <div
        className="d-flex align-items-center"
        style={{ cursor: "pointer" }}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <Button
          variant="link"
          size="sm"
          style={{
            display: "inline-block",
            padding: 0,
            margin: 0,
            textDecoration: "none",
            marginRight: "4px",
            focus: "none",
            outline: "none",
            border: "none",
            boxShadow: "none",
            fontWeight: "bold",
          }}
        >
          {isExpanded ? "−" : "+"}
        </Button>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            margin: 0,
          }}
        >
          QUALIFICATIONS
        </p>
      </div>
      <div className={`${isExpanded ? "d-block" : "d-none"}`}>
        <MultiSelectQualificationsWithSelectAll
          qualificationsMap={qualificationsMap}
          filterKey="qualifications"
          title="Qualifications"
          currentFilterValue={qualifications}
          all_qualifications={all_qualifications}
          updateFilter={updateFilter}
          dispatchLocal={dispatchLocal}
        />
      </div>
    </div>
  );
};

export default QualificationsFilter;
